import { TodoItem } from 'types';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Icon from '@/icons';
import ErrorBoundary from '@/ErrorBoundary';

export default function TodoChannelItem({ item, permissions }: { item: TodoItem, permissions?: any }) {
    const [itemFocused, setItemFocused] = useState(false);
    const [task, setTask] = useState(item.content);
    const { channelId } = useParams();

    const saveTask = async () => {
        if (!task.trim()) return setTask(item.content);
        await fetch(`__SITE_BASE__/api/v1/channels/${channelId}/todo/item/${item.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                content: task,
            })
        });
    }

    const deleteTask = async () => {
        await fetch(`__SITE_BASE__/api/v1/channels/${channelId}/todo/item/${item.id}`, {
            method: 'DELETE',
        });
    }

    useEffect(() => {
        setTask(item.content);
    }, [item.content]);

    const completeTask = async () => {
        await fetch(`__SITE_BASE__/api/v1/channels/${channelId}/todo/item/${item.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                changeCompleted: true,
            })
        });
    }

    const cloneTask = async () => {
        await fetch(`__SITE_BASE__/api/v1/channels/${channelId}/todo/item/${item.id}/clone`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }

    return (
        <div className={`group flex-col gap-2 items-center bg-brand-dark rounded-md`}>
            <ErrorBoundary>
                <div className="flex px-2 sm:px-24 py-4 items-center">
                    <div className="flex gap-2 items-center p-2 cursor-pointer">
                        <div className={`w-6 h-6 rounded-full flex items-center justify-center border-2 border-brand-green transition-all duration-200 ${item.completed ? "bg-brand-green" : ""} ${permissions?.allow.includes("EDIT_TODOS") ? "cursor-pointer" : "cursor-not-allowed"}`} onClick={
                            permissions?.allow.includes("EDIT_TODOS") ? completeTask : undefined
                        } />
                    </div>
                    <input
                        type="text"
                        className="p-2 bg-brand-dark w-full rounded-lg text-white focus:outline-none"
                        value={task}
                        disabled={!permissions?.allow.includes("EDIT_TODOS")}
                        onChange={(e) => setTask(e.target.value)}
                        onFocus={() => {
                            setItemFocused(
                                permissions?.allow.includes("EDIT_TODOS")
                            )
                        }}
                        onBlur={() => { setItemFocused(false) }}
                    />
                    <div className='gap-2 items-center justify-center flex'>
                        {permissions?.allow.includes("DELETE_TODOS") && (
                            <button className="group-hover:block hidden items-center" onClick={deleteTask}>
                                <Icon name="delete" size="20" color="#de0a26" />
                            </button>
                        )}

                        {permissions?.allow.includes("CREATE_TODOS") && (
                            <button className="group-hover:block hidden items-center" onClick={cloneTask}>
                                <Icon name="clone" size="20" color="#00b0ff" />
                            </button>
                        )}
                    </div>
                </div>
                {itemFocused && (
                    <div className="flex gap-2 px-2 sm:px-24 items-center p-2 cursor-pointer">
                        <button className="bg-brand-green p-2 rounded-lg" onMouseDown={saveTask}>Save</button>
                    </div>
                )}
            </ErrorBoundary>
        </div>
    );
}
